/* eslint-disable max-lines */
/* eslint-disable max-params */
/* eslint-disable camelcase */
import CheckoutConstants, {
  DUMMY_ADDRESS_VALUES_FOR_APPLE_PAY,
  ORDER_TYPE,
  PAYMENT_METHODS,
} from '@tcp/core/src/components/features/CnC/Checkout/Checkout.constants';
import logger from '@tcp/core/src/utils/loggerInstance';
import getCartCachedQuery from '@tcp/core/src/queries/getCartCached.query.graphql';
import getCartCachedApplePayQuery from '@tcp/core/src/queries/getCartDetailsApplePay.query.graphql';
import getBasketInventoryDetails from '@tcp/core/src/queries/getBasketInventory.query.graphql';
import getBasketInventory from '@tcp/core/src/queries/fetchInventory.query.graphql';
import getCartNonCachedQuery from '@tcp/core/src/queries/getCartNonCached.query.graphql';
import removeItemFromBasketquery from '@tcp/core/src/queries/removeItemFromBasket.query.graphql';
import removeItemListFromBasketquery from '@tcp/core/src/queries/removeItemListFromBasket.query.graphql';
import updateBackpackItemInBasket from '@tcp/core/src/queries/updateBackpackItemInBasket.query.graphql';
import updateItemInBasket from '@tcp/core/src/queries/updateItemInBasket.query.graphql';
import updateStoreItemInBasket from '@tcp/core/src/queries/updateStoreItemInBasket.query.graphql';
import CacheConfiguration from '@tcp/core/src/services/handler/graphQL/clients/retryConfiguration';
import {
  checkCache,
  getAPIConfig,
  getTranslateDateInformation,
  readCookie,
} from '@tcp/core/src/utils';
import {
  updateKeyWithValue,
  hasGiftOptionWithPromotion,
} from '@tcp/core/src/services/abstractors/SFCC/ApplyCoupon.js';
import {
  FREE_GIFT_WRAPPING,
  IS_APPLIED_TO_BASKET,
  IS_ON_HOLD,
} from '@tcp/core/src/components/features/CnC/common/organism/CouponAndPromos/Coupon.constants.js';
import getLoyaltyBenefits from '@tcp/core/src/queries/getLoyaltyBenefits.query.graphql';
import shipmentProductInventory from '@tcp/core/src/queries/shipmentProductInventory.query.graphql';
import PaypalAuthenticationMutation from '@tcp/core/src/queries/paypalAuthentication.query.graphql';
import { graphQlErrorHandler } from '@tcp/core/src/utils/errorMessage.util';
import isEmpty from 'lodash/isEmpty';
import { SubmissionError } from 'redux-form';
import CARTITEMTILE_CONSTANTS from '../../../components/features/CnC/CartItemTile/CartItemTile.constants';
import {
  extractPrioritizedBadge,
  getCustomCartProductAttributes,
  parseBoolean,
} from '../../../utils/badge.util';
import {
  getDynamicCodeErrorMessage,
  getFormattedError,
  responseContainsErrors,
  ServiceResponseError,
} from '../../../utils/errorMessage.util';
import { parseStoreOpeningAndClosingTimes } from '../../../utils/parseStoreHours';
import { executeStatefulGraphQLQuery, executeStatefulAPICall } from '../../handler';
import { updateInventory, formProdItemsWithLoyaltyAttr } from './AddedToBag';
import endpoints from '../../endpoints';
import { formatBundleData } from '../../../components/common/atoms/BundleTracker/util/utility';

const RES_NULL_ERROR = 'res body is null';

const NETWORK_ONLY = 'network-only';

export const ORDER_ITEM_TYPE = {
  BOSS: 'BOSS',
  BOPIS: 'BOPIS',
  ECOM: 'ECOM',
};

export const AVAILABILITY = {
  ...CARTITEMTILE_CONSTANTS.AVAILABILITY,
};

export const COUPON_STATUS = {
  AVAILABLE: 'available',
  EXPIRING_SOON: 'expiration-limit',
  APPLYING: 'applying',
  APPLIED: 'applied',
  PENDING: 'pending',
  REMOVING: 'removing',
};

export const BUTTON_LABEL_STATUS = {
  APPLY: 'APPLY',
  REMOVE: 'REMOVE',
};

export const COUPON_REDEMPTION_TYPE = {
  PUBLIC: 'public',
  WALLET: 'wallet',
  REWARDS: 'rewards',
  SAVING: 'saving',
  LOYALTY: 'LOYALTY',
  PLACECASH: 'PLACECASH',
  PC: 'PLACECASH',
};

export const getSwatchImgPath = (id, excludeExtension) => {
  const imageName = id && id.split('_');
  const imagePath = imageName ? imageName[0] : '';
  return imagePath ? `${imagePath}/${id}${excludeExtension ? '' : '.jpg'}` : '';
};

export const getValueFromResponse = (benefits, type, keyName) => {
  const benefit = benefits.find((item) => item?.type === type);
  return benefit ? benefit[keyName] : null;
};

export const getProductImgPath = (id, excludeExtension) => {
  const imageName = id && id.split('_');
  const imagePath = imageName ? imageName[0] : '';
  return imagePath
    ? {
        125: `${imagePath}/${id}${excludeExtension ? '' : '.jpg'}`,
        380: `${imagePath}/${id}${excludeExtension ? '' : '.jpg'}`,
        500: `${imagePath}/${id}${excludeExtension ? '' : '.jpg'}`,
        900: `${imagePath}/${id}${excludeExtension ? '' : '.jpg'}`,
      }
    : {};
};

export const imageGenerator = (id, excludeExtension) => {
  return {
    colorSwatch: getSwatchImgPath(id, excludeExtension),
    productImages: getProductImgPath(id, excludeExtension),
  };
};

export const getPdpUrl = (imgUrl, prodPartNo = '') => {
  const [, imageNameWithExt = ''] = (imgUrl || '').split('/');
  const [imageName = ''] = imageNameWithExt.split('.');
  const { siteId } = getAPIConfig();
  return `/${siteId}/p/${imageName || prodPartNo}`;
};

// NOTE: (DT-19681) LOYALTY/PLACECASH/OTHERS
export function getPromotionType(promotionType) {
  switch (promotionType) {
    case 'PC':
      return COUPON_REDEMPTION_TYPE.PLACECASH;
    case 'LOYALTY':
      return COUPON_REDEMPTION_TYPE.LOYALTY;
    default:
      return COUPON_REDEMPTION_TYPE.PUBLIC;
  }
}

export const flatCurrencyToCents = (currency = 0) => {
  try {
    return parseFloat(
      currency
        .toFixed(2)
        .toString()
        .match(/^-?\d+(?:\.\d{0,2})?/)[0]
    );
  } catch (e) {
    throw new Error(e);
  }
};

export const capitalize = (string) => {
  return string ? string.replace(/\b\w/g, (l) => l.toUpperCase()) : '';
};

export const sanitizeEntity = (string) => {
  return string && typeof string === 'string'
    ? string
        .replace(/&amp;/gi, '&')
        .replace(/&quot;/gi, '"')
        .replace(/&ldquo;/gi, '"')
        .replace(/&acute;/gi, '"')
        .replace(/&prime;/gi, '"')
        .replace(/&bdquo;/gi, '"')
        .replace(/&ldquot;/gi, '"')
        .replace(/\\u0027/gi, "'")
        .replace(/&lsquot;/gi, '"')
        .replace(/%20/gi, ' ')
    : string;
};

const deriveBossInventoryMismatch = (item) => {
  // RAD-88/86 qty - requested quantity,inventoryAvailBOSS - available quantity at FFMC
  return item.quantity > item.inventoryAvailBOSS;
};

const getIsProductOK = ({ orderItemType, stLocId, bopisIntlField }) => {
  return orderItemType === ORDER_ITEM_TYPE.BOPIS && stLocId && !parseBoolean(bopisIntlField);
};

const getIsProductUnavailble = ({ bossIntlField, isStoreBOSSEligible }) =>
  parseBoolean(bossIntlField) || !isStoreBOSSEligible;

const getAvailablityIfIsRadialInv = ({ item }) => {
  // const isProductBossEligible = deriveBossEligiblity(item, orderDetails); // product ineligibility added as part of RAD-88, not present earlier in production
  const isProductBossEligible = false;
  if (item.inventoryAvailBOSS <= 0) {
    return AVAILABILITY.UNAVAILABLE;
  }
  if (deriveBossInventoryMismatch(item)) {
    return AVAILABILITY.REQ_QTY_UNAVAILABLE;
  }
  if (!isProductBossEligible) {
    return AVAILABILITY.BOSSINELIGIBLE;
  }

  return AVAILABILITY.OK;
};

const getDefaultAvailability = ({ item }) => {
  if (item.inventoryAvail > 0) {
    return AVAILABILITY.OK;
  }
  return AVAILABILITY.UNAVAILABLE;
};

export const deriveItemAvailability = (orderDetails, item, store, isRadialInvEnabled) => {
  const { c_bopisIntlField, c_bossIntlField } = orderDetails;
  const { itemId, c_orderItemType } = item;
  if (getIsProductOK({ c_orderItemType, itemId, c_bopisIntlField })) {
    return AVAILABILITY.OK;
  }
  if (item.orderItemType === ORDER_ITEM_TYPE.BOSS && itemId) {
    const isStoreBOSSEligible = store
      ? parseBoolean(store.shippingAddress.isStoreBOSSEligible)
      : true;
    /**
     * Adding new check to return status unavailable in case of:
     * 1. international order - exisiting
     * 2. boss store ineligible - exisiting
     * 3. boss item inventory zero - added with RAD-88/RAD-86
     * 4. boss item inventory mismatch(requested qty > avail qty) - added with RAD-88/RAD-86
     * 5. boss product ineligible -  added with RAD-88/RAD-86
     * returning respective updated Error copies(RAD-86)
     */
    if (getIsProductUnavailble({ c_bossIntlField, isStoreBOSSEligible })) {
      return AVAILABILITY.UNAVAILABLE;
    }
    if (isRadialInvEnabled) {
      return getAvailablityIfIsRadialInv({ item, orderDetails });
    }
    return getDefaultAvailability({ item });
  }
  if (item.quantity > item.inventoryAvail) {
    return AVAILABILITY.UNAVAILABLE;
  }
  if (item.inventoryAvail > 0) {
    // inventory check for BOSS and ECOM
    return AVAILABILITY.OK;
  }
  return AVAILABILITY.UNAVAILABLE;
};

export const deriveBossEligiblity = (item, orderDetailsResponse) => {
  return !(
    parseBoolean(item.c_itemTcpBossProductDisabled) ||
    parseBoolean(item.c_itemTcpBossCategoryDisabled) ||
    orderDetailsResponse.c_bossIntlField
  );
};

export const priceDropNotification = ({ payload, sflId }) => {
  const apiPayload = {
    body: {
      basketItems: payload?.basketItems || false,
      saveForLater: payload?.saveForLater || false,
      saveForLaterListId: payload?.saveForLater ? sflId || '' : '',
    },
    webService: endpoints.priceDropUpdate,
  };
  return executeStatefulAPICall(apiPayload, null, true)
    .then((res) => res)
    .catch((err) => {
      throw getFormattedError(err, []);
    });
};

/* eslint-disable complexity, max-statements */
// eslint-disable-next-line sonarjs/cognitive-complexity
export const getOrderItemFormatter = (orderDetail) => {
  const EMPTY_OBJECT = Object.create(null);
  let totalItems = 0;
  const orderItems = [];
  const orderAccessorieItems = {};
  const { language } = getAPIConfig();

  // eslint-disable-next-line sonarjs/cognitive-complexity
  if (orderDetail.productItems) {
    Object.values(orderDetail.productItems || []).forEach((itemValue) => {
      const item = JSON.parse(JSON.stringify(itemValue));
      item.itemPoints = null;
      let store;
      let orderNo;
      if (orderDetail?.shipments) {
        orderDetail.shipments.map((shipment) => {
          if (shipment.shipmentId === item.shipmentId) {
            orderNo = shipment.c_orderNo;
            if (item.c_orderItemType) {
              store = shipment;
            }
          }
          return store;
        });
      }
      const { shippingAddress = {} } = store || {};
      const { isStoreBOSSEligible = false } = shippingAddress || {};
      const bossMinDate = store?.bossMinDate || store?.c_bossMinDate;
      const bossMaxDate = store?.bossMaxDate || store?.c_bossMaxDate;
      if (!item.c_giftOption) {
        totalItems += parseInt(item.quantity, 10);

        const { todayOpeningTime, todayClosingTime, tomorrowOpeningTime, tomorrowClosingTime } =
          parseStoreOpeningAndClosingTimes(store);

        const isGiftCard = item.c_giftItem;
        const itemUnitDstPrice = +`${Math.round(
          `${item.priceAfterOrderDiscount / item.quantity}e+2`
        )}e-2`;
        const itemUnitPrice = +`${Math.round(`${item.price / item.quantity}e+2`)}e-2`;
        const name = sanitizeEntity(item.productName);
        const createdOrderItem = {
          productInfo: {
            generalProductId: item?.productId,
            productPartNumber: item.c_prodPartNo,
            skuId: item.productId,
            itemPartNumber: item.productId,
            variantNo: item.productId,
            name,
            imagePath: imageGenerator(item.c_prodPartNo).productImages[500],
            upc: item.productId,
            size: item.c_size || itemUnitDstPrice.toString() || '',
            fit: item.c_fit || '',
            pdpUrl: getPdpUrl(item.c_TCPimages, item.c_prodPartNo),
            color: {
              name: isGiftCard ? name : item.c_TCPColor || item.productName,
            },
            isGiftCard,
            colorFitSizeDisplayNames: isGiftCard
              ? { color: 'Design', size: 'Value' }
              : EMPTY_OBJECT,
            // added to read type of order for the item
            orderType: (item.c_orderItemType && item.c_orderItemType.toUpperCase()) || 'PURE_ECOM',
            itemBrand: item.c_brand || 'TCP',
            multiPack: item.c_multiPack,
            shipmentId: item.shipmentId || '',
            orderNo,
            multiPackItems: item.c_multiPackItems,
            tcpStyleQty: item.c_TCPStyleQTY || '',
            tcpStyleType: item.c_TCPStyleType || '',
            variant: item.c_variant || '',
            seoToken: item.c_seoToken,
          },
          itemInfo: {
            quantity: parseInt(item.quantity, 10),
            itemId: item.itemId.toString(),
            itemPoints: item.itemPoints,
            listPrice: flatCurrencyToCents(item.priceAfterOrderDiscount),
            offerPrice: flatCurrencyToCents(item.priceAfterOrderDiscount),
            wasPrice: flatCurrencyToCents(item.c_list_price),
            itemUnitDstPrice: item.priceAfterOrderDiscount,
            itemUnitPrice: item.basePrice,
            price: item?.price,
            // eslint-disable-next-line no-nested-ternary
            salePrice: flatCurrencyToCents(itemUnitPrice),
            preOrderDate: item?.preOrderDate,
            bundledProductItems: item?.bundledProductItems,
            lastViewedTime: item?.c_lastViewedTime,
            lastViewedPrice: item?.c_lastViewedPrice,
            taxClassId: item?.taxClassId,
            priceAfterItemDiscount: item?.priceAfterItemDiscount,
          },
          miscInfo: {
            clearanceItem: item?.c_TCPProductIndStore === 'Clearance',
            isHardMarkEnabled: item?.c_isHardMarkEnabled,
            shippingRestrictedStates: item?.shippingRestrictedStates,
            TCPProductIndStore: item.c_TCPProductIndStore,
            isOnlineOnly: item.c_TCPWebOnlyFlagStore,
            online: true,
            isBopisEligible: !parseBoolean(orderDetail.c_bopisIntlField), // confirm mapping SFCC-TODO
            isBossEligible: deriveBossEligiblity(item, orderDetail), // confirm mapping SFCC-TODO
            isBossTileEligible: !(
              parseBoolean(item.c_itemTcpBossProductDisabled) ||
              parseBoolean(item.c_itemTcpBossCategoryDisabled)
            ),
            badge: extractPrioritizedBadge(item, getCustomCartProductAttributes()),
            isInventoryAvailBOSS: true, // setting default true, this value will get override by basketInventorydetail.
            availability: AVAILABILITY.OK, // setting default OK, this value will get override by basketInventorydetail.
            availabilitySTH: AVAILABILITY.OK,
            storeId: item.c_fromStoreId || null,
            orderItemType:
              (item.c_orderItemType && item.c_orderItemType.toUpperCase()) || 'PURE_ECOM',
            // onlineInventoryAvailable: item.inventoryAvail,
            // TODO: cleanup structure
            // store, isStoreBOSSEligible, storeAddress, storePhoneNumber, storeTodayOpenRange, storeTomorrowOpenRange,
            // bossStartDate, bossEndDate and storeItemsCount will get override by basketInventorydetail.
            store: store && shippingAddress ? capitalize(shippingAddress?.c_storeName) : null,
            storeHours: store && shippingAddress ? shippingAddress?.c_storeHours : null,
            isStoreBOSSEligible:
              store && shippingAddress
                ? isStoreBOSSEligible?.toUpperCase() === 'Y' || parseBoolean(isStoreBOSSEligible)
                : false,
            storeAddress:
              store && shippingAddress
                ? {
                    addressLine1: capitalize(shippingAddress.address1),
                    addressLine2: shippingAddress?.address2,
                    city: capitalize(shippingAddress?.city),
                    state: shippingAddress?.stateCode,
                    zipCode: shippingAddress.postalCode?.trim(),
                  }
                : null,
            // store making store details visible for both BOSS and BOPIS
            storePhoneNumber:
              store && shippingAddress ? (shippingAddress?.phone || '').trim() : null,
            storeTodayOpenRange:
              store && shippingAddress ? `${todayOpeningTime} -  ${todayClosingTime}` : null,
            storeTomorrowOpenRange:
              store && shippingAddress ? `${tomorrowOpeningTime} - ${tomorrowClosingTime}` : null,
            // dates for boss pickup, used getDateInformation utility
            bossStartDate:
              item.c_orderItemType === ORDER_ITEM_TYPE.BOSS
                ? getTranslateDateInformation(bossMinDate, language)
                : null,
            bossEndDate:
              item.c_orderItemType === ORDER_ITEM_TYPE.BOSS
                ? getTranslateDateInformation(bossMaxDate, language)
                : null,
            // shows number of items from the store
            storeItemsCount: store ? +store.itemsCount : 0,
            TCPPromotions: item.TCPPromotions || item.c_bundlePromoId,
            vendorColorDisplayId: '',
            c_accessories: item.c_accessories,
            c_customizationType: item.c_customizationType || null,
            variantPreOrderMap: item?.variantPreOrderMap || {},
            c_mainProducts: item.c_mainProducts || null,
            c_priceIncluded: item.c_priceIncluded,
            priceAdjustments: item.priceAdjustments || [],
            tcpBigIdeaLicensedProductBrand: item?.c_TCPBigIdeaLicensedProductBrand,
          },
        };
        orderAccessorieItems[item.productId] = JSON.parse(JSON.stringify(createdOrderItem));
        orderItems.push(JSON.parse(JSON.stringify(createdOrderItem)));
      }
    });
  }
  return { totalItems, orderItems, orderAccessorieItems };
};

const getOrderTypes = (items) => {
  let obj = {};
  if (items) {
    let isBossOrder = items.find((store) => {
      return store?.c_orderItemType?.toUpperCase() === ORDER_ITEM_TYPE.BOSS;
    });
    let isBopisOrder = items.find(
      (store) => store?.c_orderItemType?.toUpperCase() === ORDER_ITEM_TYPE.BOPIS
    );
    let isECOM = items.find(
      (store) =>
        store?.c_orderItemType?.toUpperCase() === ORDER_ITEM_TYPE.ECOM || !store?.c_orderItemType
    );
    isBopisOrder = !!isBopisOrder;
    isBossOrder = !!isBossOrder;
    isECOM = !!isECOM;
    const isPickupOrder = isBopisOrder || isBossOrder;

    let orderType = '';
    if (isECOM && !isBopisOrder && !isBossOrder) {
      // Pure ECOM
      orderType = ORDER_TYPE.PURE_ECOM;
    } else if (isBopisOrder && !isECOM && !isBossOrder) {
      // Pure BopisOrder
      orderType = ORDER_TYPE.PURE_BOPIS;
    } else if (isBossOrder && !isECOM && !isBopisOrder) {
      // Pure BOSS
      orderType = ORDER_TYPE.PURE_BOSS;
    } else if (isECOM && (isBossOrder || isBopisOrder)) {
      orderType = ORDER_TYPE.ECOM_MIX;
    } else if (isBossOrder && isBopisOrder && !isECOM) {
      orderType = ORDER_TYPE.BOSS_AND_BOPIS;
    }
    obj = {
      isBopisOrder,
      isBossOrder,
      isECOM,
      isPickupOrder,
      orderType,
    };
  }
  return obj;
};

const getisShippingCouponApplied = (shippingItems) => {
  if (Array.isArray(shippingItems)) {
    return shippingItems.some((items) => {
      if (items && Array.isArray(items.priceAdjustments)) {
        return items.priceAdjustments[0]?.couponCode || false;
      }
      return false;
    });
  }
  return false;
};

const getStoreDetails = (orderDetail) => {
  const stores = [];
  const { language } = getAPIConfig();

  if (orderDetail?.shipments) {
    Object.values(orderDetail.shipments).forEach((store, index) => {
      if (index !== 0) {
        const bossMinDate = store?.bossMinDate || store?.c_bossMinDate;
        const bossMaxDate = store?.bossMaxDate || store?.c_bossMaxDate;
        const { shippingAddress = {}, shippingMethod = {}, c_fromStoreId = '' } = store;
        const {
          id = '',
          c_storeName = '',
          c_addressId = '',
          c_altName = '',
          address1 = '',
          address2 = '',
          city = '',
          stateCode = '',
          countryCode = '',
          postalCode = '',
          c_storeHours = '',
        } = shippingAddress;
        stores.push({
          stLocId: id || '',
          itemsCount: store.itemsCount,
          storeName: capitalize(c_storeName),
          orderType: shippingMethod.id,
          c_fromStoreId,
          address: {
            addressId: c_addressId,
            addessKey: c_altName,
            address: capitalize(address1),
            addressLine1: capitalize(address1),
            addressLine2: capitalize(address2),
            city: capitalize(city),
            state: capitalize(stateCode),
            country: capitalize(countryCode),
            zipCode: postalCode?.trim(),
          },
          bossStartDate:
            shippingMethod.id === ORDER_ITEM_TYPE.BOSS
              ? getTranslateDateInformation(bossMinDate, language)
              : null,
          bossEndDate:
            shippingMethod.id === ORDER_ITEM_TYPE.BOSS
              ? getTranslateDateInformation(bossMaxDate, language)
              : null,
          storeHours: c_storeHours,
          isStoreBOSSEligible: parseBoolean(store.isStoreBOSSEligible),
        });
      }
    });
  }
  return stores;
};

// eslint-disable-next-line sonarjs/cognitive-complexity
export const getOrderSummaryFormatter = (orderDetail) => {
  const orderSummary = {};
  let orderTypes = {};
  let promotionTotal = flatCurrencyToCents(orderDetail.c_promotionTotal || 0);
  if (promotionTotal < 0) {
    promotionTotal *= -1;
  }
  let couponsTotal = flatCurrencyToCents(orderDetail.c_couponTotal || 0);
  if (couponsTotal < 0) {
    couponsTotal *= -1;
  }
  if (orderDetail.totalGiftCardAmount) {
    orderSummary.giftCardsTotal = flatCurrencyToCents(orderDetail.totalGiftCardAmount || 0);
  }
  if (orderDetail.c_earnPlaceCashAmount >= 0) {
    orderSummary.rewardsToBeEarned = flatCurrencyToCents(orderDetail.c_earnPlaceCashAmount || 0);
  }
  if (orderDetail.c_earnPlaceCashCoupon >= 0) {
    orderSummary.c_earnPlaceCashCoupon = orderDetail.c_earnPlaceCashCoupon || 0;
  }
  if (orderDetail.c_earnPlaceProximity >= 0) {
    orderSummary.c_earnPlaceProximity = flatCurrencyToCents(orderDetail.c_earnPlaceProximity || 0);
  }
  if (orderDetail.taxTotal >= 0) {
    orderSummary.totalTax = flatCurrencyToCents(orderDetail.taxTotal || 0);
  }
  if (orderDetail.productTotal) {
    orderSummary.productTotal = flatCurrencyToCents(orderDetail.productTotal || 0);
  }
  if (orderDetail.orderTotal || orderDetail.productTotal) {
    orderSummary.grandTotal = flatCurrencyToCents(
      orderDetail.orderTotal ||
        orderDetail.productTotal + orderDetail.shippingTotal + orderDetail.taxTotal ||
        0
    );
  }
  if (orderDetail.c_productTotalWithOutGift) {
    orderSummary.subTotal = flatCurrencyToCents(orderDetail.c_productTotalWithOutGift || 0);
  }
  if (orderDetail.productSubTotal) {
    orderSummary.subTotalWithDiscounts = flatCurrencyToCents(orderDetail.productSubTotal || 0);
  }
  if (orderDetail.shippingItems) {
    orderSummary.isFreeShippingCouponApplied = getisShippingCouponApplied(
      orderDetail.shippingItems
    );
  }
  if (orderDetail.orderSubTotalWithoutGiftCard) {
    orderSummary.subTotalWithoutGiftCard = flatCurrencyToCents(
      orderDetail.orderSubTotalWithoutGiftCard || 0
    );
  }
  if (orderDetail.c_giftPrice >= 0) {
    orderSummary.giftWrappingTotal = flatCurrencyToCents(orderDetail.c_giftPrice || 0);
  }
  if (orderDetail.c_giftDiscount !== 0) {
    orderSummary.giftDiscountTotal = flatCurrencyToCents(orderDetail.c_giftDiscount || 0);
  }
  if (orderDetail?.pointsToRedeem) {
    orderSummary.pointsToRedeem = orderDetail.pointsToRedeem;
  }
  if (orderDetail.c_taxIdentifierAttribute) {
    orderSummary.taxIdentifierAttribute = orderDetail.c_taxIdentifierAttribute;
  }
  if (orderDetail?.shipments) {
    orderSummary.shipments = orderDetail.shipments;
    orderSummary.stores = getStoreDetails(orderDetail);
  }
  if (orderDetail?.productItems) {
    orderTypes = getOrderTypes(orderDetail.productItems);
  }
  if (orderDetail.airMiles) {
    const airMilesData = JSON.parse(orderDetail.airMiles);
    const { c_airMilesAccount = '', c_airMilesDeal = '' } = airMilesData || {};
    orderSummary.airmiles = {
      accountNumber: c_airMilesAccount,
      promoId: c_airMilesDeal,
    };
  }
  return {
    orderId: orderDetail.basketId,
    savingsTotal: promotionTotal < 0 ? 0 : promotionTotal,
    couponsTotal: couponsTotal < 0 ? 0 : couponsTotal,
    totalOrderSavings: flatCurrencyToCents(orderDetail.c_totalSavings || 0),
    applePayShippingTotal: flatCurrencyToCents(orderDetail.shippingTotal || 0),
    shippingTotal: flatCurrencyToCents(orderDetail.shippingTotal || 0),
    cartTotalAfterPLCCDiscount: flatCurrencyToCents(orderDetail.c_cartTotalAfterPLCCDiscount || 0),
    orderPriceAdjustments: orderDetail.orderPriceAdjustments,
    // isPaypalEnabled: parseBoolean(orderDetail.payPalAllowed || orderDetail.isPayPalAllowed),
    isPaypalEnabled: true, // setting up as an default value, will change in later sprints SFCC-TODO
    isShippingOrder: orderTypes.isECOM,
    ...orderSummary,
    ...orderTypes,
  };
};

export const getOrderCouponFormatter = (orderDetail) => {
  const couponObj = {};
  if (orderDetail.couponItems) {
    couponObj.couponItems = orderDetail.couponItems;
  }
  if (orderDetail.c_couponMap) {
    couponObj.c_couponMap = orderDetail.c_couponMap;
  }
  return {
    ...couponObj,
  };
};
export const getOrderShippingFormatter = (orderDetail) => {
  let shipping = {};
  const shipment = (orderDetail.shipments && orderDetail.shipments[0]) || {};
  const { shippingAddress, shippingMethod, shipmentId } = shipment;
  if (typeof orderDetail.shipments === 'undefined') {
    shipping = {
      noReduxUpdate: true,
    };
  }
  if (shippingAddress && shippingAddress.address1 !== DUMMY_ADDRESS_VALUES_FOR_APPLE_PAY.address1) {
    shipping = {
      address: {
        firstName: shippingAddress.firstName,
        lastName: shippingAddress.lastName,
        addressLine1: shippingAddress.address1,
        addressLine2: shippingAddress.address2,
        city: shippingAddress.city,
        state: shippingAddress.stateCode,
        zipCode: (shippingAddress.postalCode || '').trim(),
        country: shippingAddress.countryCode,
        id: shippingAddress?.id,
        phone: shippingAddress?.phone,
        // eslint-disable-next-line camelcase
        addressId: shippingAddress?.c_addressId,
        // eslint-disable-next-line camelcase
        validationCode: shippingAddress?.c_validationCode,
        phoneCountryCode: shippingAddress?.c_phoneCountryCode,
        // nickName: shipment.shipmentId,
      },
      emailAddress: shippingAddress.c_emailAddress,
      phoneNumber: shippingAddress.phone,
      deliveryIndicator: shipment.c_deliveryIndicator,
      vibesSmsPhoneNo: shipment.vibesSmsPhoneNo,
      // onFileAddressKey: shipment.shipmentId,
      // onFileAddressId: shipment.shipmentId,
    };
  }
  if (shippingMethod) {
    shipping = {
      ...shipping,
      method: {
        shippingMethodId: shippingMethod.id,
        displayName: shippingMethod?.description?.split('-')[0]?.trim(),
        code: shippingMethod.c_code,
        name: shippingMethod.name?.split('-')[0]?.trim(),
        shippingSpeed: shippingMethod?.description?.split('-')[1]?.trim(),
      },
    };
  }
  return {
    shipmentId: shippingMethod?.id ? shippingMethod?.id : shipmentId,
    shipping,
  };
};

export const getOrderGiftWrapFormatter = (orderDetail) => {
  const { c_giftMessage: giftMsg, productItems = [] } = orderDetail;
  let giftWrap = null;
  if (productItems.length > 0) {
    const giftProduct = productItems.find((item) => item.c_giftOption);
    giftWrap = {};
    if (giftProduct) {
      giftWrap = {
        optionId: giftProduct.productId.toString(),
        message: giftMsg || '',
        brand: giftProduct.c_brand || '',
        name: giftProduct.productName || '',
        price: giftProduct.price || '',
        hasGiftWrapping: true,
      };
    }
  }

  // giftWrap {} - Order contains no gift option
  // giftWrap null - May be, order contains gift option but in query products have not been asked
  return giftWrap
    ? {
        giftWrap,
      }
    : {};
};

export const getGifCardDetailsFormatter = (orderDetail) => {
  const giftCardDetails = [];
  const appliedGiftCards = [];
  let giftCardsTotal = 0;

  const { paymentInstruments } = orderDetail;

  if (paymentInstruments && paymentInstruments.length !== 0) {
    paymentInstruments
      .filter((giftData) => giftData.paymentMethodId === CheckoutConstants.GIFT_CERTIFICATE)
      .forEach((giftData) => {
        const {
          paymentInstrumentId,
          amount,
          maskedGiftCertificateCode = '',
          giftCardBalance,
          c_savedPI,
          c_giftCardBalance,
        } = giftData;
        const giftAmount = parseFloat(amount, 10);
        const remainingBalance = parseFloat(giftCardBalance || c_giftCardBalance, 10) || 0;

        giftCardDetails.push({
          piId: paymentInstrumentId,
          creditCardId: '',
          giftAmount,
          giftCardNumber: (maskedGiftCertificateCode && maskedGiftCertificateCode.substr(-4)) || '',
          remainingBalance,
        });

        appliedGiftCards.push({
          id: paymentInstrumentId,
          savedPI: c_savedPI,
          onFileCardId: '',
          amountApplied: giftAmount,
          endingNumbers: (maskedGiftCertificateCode && maskedGiftCertificateCode.substr(-4)) || '',
          remainingBalance,
        });

        giftCardsTotal += giftAmount;
      });
  }

  return {
    giftCardDetails,
    appliedGiftCards,
    giftCardsTotal: parseFloat(giftCardsTotal.toFixed(2)),
  };
};

const getCardTypeFormatter = (cardType) => {
  const cardTypeInLower = cardType.toLowerCase();
  let cardTypeInCaps = cardType.toUpperCase();
  if (cardTypeInLower === 'master card') {
    cardTypeInCaps = 'MC';
  } else if (cardTypeInLower === 'discover') {
    cardTypeInCaps = 'DISC';
  } else if (cardTypeInLower === 'placecard') {
    cardTypeInCaps = 'PLACE CARD';
  }
  return cardTypeInCaps;
};

// eslint-disable-next-line sonarjs/cognitive-complexity
export const getOrderBillingFormatter = (orderDetail) => {
  const { billingAddress: billAddress, paymentInstruments } = orderDetail;
  let billing = {};
  if (typeof orderDetail.paymentInstruments === 'undefined') {
    billing = {
      noReduxUpdate: true,
    };
  }
  if (billAddress && billAddress.address1 !== DUMMY_ADDRESS_VALUES_FOR_APPLE_PAY.address1) {
    billing = {
      address: {
        firstName: billAddress.firstName,
        lastName: billAddress.lastName,
        addressLine1: billAddress.address1,
        addressLine2: billAddress.address2,
        city: billAddress.city,
        state: billAddress.stateCode,
        zipCode: (billAddress.postalCode || '').trim(),
        country: billAddress.countryCode,
        addressId: billAddress.c_addressId,
        addressType: billAddress.c_addressType,
        sameAsShipping: billAddress.c_sameAsShippingAddress,
      },
    };
    if (!isEmpty(paymentInstruments) && paymentInstruments.length > 0) {
      const {
        paymentCard,
        paymentMethodId,
        paySecureFailed,
        c_savedPI,
        paymentInstrumentId,
        recaptchaToken,
      } =
        paymentInstruments.find(({ paymentMethodId: methodId }) =>
          PAYMENT_METHODS.includes(methodId)
        ) || {};

      if (paymentMethodId) {
        billing = {
          ...billing,
          paymentMethod: paymentMethodId,
          recaptchaToken,
        };
      }
      if (c_savedPI) {
        billing = {
          ...billing,
          c_savedPI,
        };
      }
      if (paymentInstrumentId) {
        billing = {
          ...billing,
          paymentInstrumentId,
          recaptchaToken,
        };
      }

      if (paymentCard) {
        const { cardType = '', expirationMonth, expirationYear, maskedNumber } = paymentCard;

        billing = {
          ...billing,
          billing: {
            cardNumber: maskedNumber,
            cardType: getCardTypeFormatter(cardType),
            expMonth: parseInt(expirationMonth, 10),
            expYear: parseInt(expirationYear, 10),
            cvv: '',
            isPaySecureFailed: paySecureFailed,
          },
          recaptchaToken,
        };
      }
    }
  }
  if (
    orderDetail?.paymentInstruments &&
    orderDetail.paymentInstruments.length &&
    orderDetail.paymentInstruments[0].afterPay
  ) {
    return {};
  }
  return {
    ...billing,
  };
};
export const getOrderLoyaltyFormatter = (orderDetail) => {
  const loyaltyObj = {};
  if (orderDetail.orderSubTotalDiscount) {
    loyaltyObj.orderSubTotalDiscount = orderDetail.orderSubTotalDiscount;
  }
  if (orderDetail.orderSubTotalWithoutGiftCard) {
    loyaltyObj.orderSubTotalWithoutGiftCard = orderDetail.orderSubTotalWithoutGiftCard;
  }
  if (orderDetail.productItems) {
    loyaltyObj.loyaltyOrderItems = orderDetail.productItems;
  }
  return { ...loyaltyObj };
};
/* eslint-disable complexity, max-statements */
export const getCurrentOrderFormatter = (
  orderDetailsResponseObj,
  loyaltyPointsRequestPayload
  // eslint-disable-next-line sonarjs/cognitive-complexity
) => {
  const orderDetailsResponse = orderDetailsResponseObj;

  // const { language } = getAPIConfig();

  // SFCC-TODO
  orderDetailsResponse.pointsToNextReward = null;
  orderDetailsResponse.userPoints = null;

  let usersOrder = {};

  usersOrder = { ...usersOrder, ...getOrderCouponFormatter(orderDetailsResponse) };

  usersOrder = { ...usersOrder, ...getOrderSummaryFormatter(orderDetailsResponse) };

  if (orderDetailsResponse.shipments || orderDetailsResponse.billingAddress) {
    const { shipmentId, shipping } = getOrderShippingFormatter(orderDetailsResponse);
    const giftWrap = getOrderGiftWrapFormatter(orderDetailsResponse);
    usersOrder.shipModeId = shipmentId;
    usersOrder.checkout = {
      pickUpContact: {},
      pickUpAlternative: {},
      shipping: {},
      giftWrap: {},
      billing: {},
    };
    usersOrder.checkout = {
      ...usersOrder.checkout,
      shipping,
      billing: getOrderBillingFormatter(orderDetailsResponse),
      giftWrap,
      ...giftWrap,
    };
  }
  if (orderDetailsResponse.productItems) {
    const { totalItems, orderItems, orderAccessorieItems } =
      getOrderItemFormatter(orderDetailsResponse);
    usersOrder.totalItems = totalItems;
    usersOrder.orderItems = orderItems;
    usersOrder.orderAccessorieItems = orderAccessorieItems;
    usersOrder.loyaltyPointsRequestPayload = {
      ...usersOrder.loyaltyPointsRequestPayload,
      ...getOrderLoyaltyFormatter(orderDetailsResponse),
    };
  }

  if (loyaltyPointsRequestPayload) {
    usersOrder.loyaltyPointsRequestPayload = loyaltyPointsRequestPayload;
  }

  return usersOrder;
};
/* eslint-enable complexity, max-statements */

export const getCartCachedData = (cacheTTL, skipCache = false) => {
  const { preFix, defaultTTL } = CacheConfiguration.GET_CART_ITEMS;

  return executeStatefulGraphQLQuery({
    query: getCartCachedQuery,
    cacheConfigKey: `${preFix}`,
    TTL: cacheTTL || defaultTTL,
    fetchPolicy: skipCache ? NETWORK_ONLY : '',
  }).then((res) => {
    if (!res.data) {
      throw new Error(RES_NULL_ERROR);
    }
    return res.data && res.data.getCart;
  });
};
export const getCartNonCachedData = () => {
  return executeStatefulGraphQLQuery({
    query: getCartNonCachedQuery,
    fetchPolicy: 'no-cache',
  }).then((resp) => {
    if (!resp.data) {
      throw new Error(RES_NULL_ERROR);
    }
    return resp.data && resp.data.getCart;
  });
};

export const getCartCachedDataApplePay = () => {
  return executeStatefulGraphQLQuery({
    query: getCartCachedApplePayQuery,
    fetchPolicy: 'no-cache',
  }).then((response) => {
    if (!response.data) {
      throw new Error(RES_NULL_ERROR);
    }
    return response.data && response.data.getCart;
  });
};

export const getCartCachedDataForPLCC = (cacheTTL, skipCache = false) => {
  const { preFix, defaultTTL } = CacheConfiguration.GET_CART_ITEMS;

  return executeStatefulGraphQLQuery({
    query: getCartCachedApplePayQuery,
    cacheConfigKey: `${preFix}`,
    TTL: cacheTTL || defaultTTL,
    fetchPolicy: skipCache ? NETWORK_ONLY : '',
  }).then((cartRes) => {
    if (!cartRes.data) {
      throw new Error(RES_NULL_ERROR);
    }
    return cartRes.data && cartRes.data.getCart;
  });
};

const setPlaceCashError = ({ err: errorObj }) => {
  const placeCash = CheckoutConstants.PLACE_CASH;

  const err = errorObj;
  const isPlaceCashError = err[0] && err[0].errorCode === placeCash;

  if (isPlaceCashError) {
    err[0].errorCode = CheckoutConstants.PLACE_CASH_ERROR;
  }
  return isPlaceCashError;
};
const errorHandler = (err, errorsMapping) => {
  const formattedErrorReq = { errorResponse: err[0] };
  const isPlaceCashError = setPlaceCashError({ err });
  const error = getFormattedError(formattedErrorReq, errorsMapping, true);
  getDynamicCodeErrorMessage(error);

  error.errorMessages = error.errorMessages || {
    _error: CheckoutConstants.SOMETHING_WENT_WRONG,
  };
  const { errorMessages: { _error = '' } = {} } = error;
  let { errorMessages } = error;

  errorMessages = { ...errorMessages, _error: { msg: _error, isPlaceCashError } };

  throw new SubmissionError(errorMessages);
};
// eslint-disable-next-line complexity
export const updateQuery = (cache, data) => {
  // eslint-disable-next-line camelcase
  const { c_couponMap, ...dataToUpdate } =
    data && (data?.removeItemFromBasket || data?.removeItemListFromBasket);
  let isCacheExist = false;
  let isBonusDayCacheExist = false;
  if (dataToUpdate) {
    isCacheExist = checkCache(cache);
    isBonusDayCacheExist = checkCache(cache, 'getLoyaltyBenefits');
  }
  if (isBonusDayCacheExist) {
    let benefits = {};
    try {
      benefits = JSON.parse(
        data?.removeItemFromBasket?.benefits || data?.removeItemListFromBasket?.benefits || '{}'
      );
    } catch (e) {
      console.error('Failed to parse benefits:', e);
    }

    const isGiftwrapperApplied = benefits?.FreeGiftWrap;
    const isFreeGiftWrapping = hasGiftOptionWithPromotion(
      data?.removeItemFromBasket?.productItems || data?.removeItemListFromBasket?.productItems
    );
    const storedData = cache.readQuery({ query: getLoyaltyBenefits });
    let updateData = storedData.getLoyaltyBenefits;
    if (isGiftwrapperApplied) {
      const isOnHold = !isFreeGiftWrapping;
      updateData = updateKeyWithValue(updateData, FREE_GIFT_WRAPPING, isOnHold, IS_ON_HOLD);

      if (!isOnHold) {
        updateData = updateKeyWithValue(updateData, FREE_GIFT_WRAPPING, true, IS_APPLIED_TO_BASKET);
      }
    }
    cache.writeQuery({
      query: getLoyaltyBenefits,
      data: { getLoyaltyBenefits: updateData },
    });
  }
  if (isCacheExist && dataToUpdate) {
    cache.writeQuery({
      query: getCartCachedQuery,
      data: { getCart: dataToUpdate },
      // broadcast: false,
    });
  }
};
export const removeItem = (
  isLoyaltyTieringEnabled,
  removeItemFromBasketItemId,
  errorsMapping,
  { orderItems = [], bundleDataItems = [], isBundleTracker = false } = {}
) => {
  const isMultipleItems = Array.isArray(removeItemFromBasketItemId);
  let query = removeItemFromBasketquery;
  const variables = {};
  if (isMultipleItems) {
    query = removeItemListFromBasketquery;
    variables.itemIds = removeItemFromBasketItemId;
  } else {
    variables.itemId = removeItemFromBasketItemId;
  }
  return executeStatefulGraphQLQuery({
    query,
    variables,
    type: 'mutation',
    updateQuery,
  })
    .then((res) => {
      if (res.errors) {
        const err = res.errors;
        errorHandler(err, errorsMapping);
      }
      const orderItemsArray = isMultipleItems
        ? removeItemFromBasketItemId
        : [removeItemFromBasketItemId];
      const deleteItemResp =
        res.data && (res.data.removeItemFromBasket || res.data.removeItemListFromBasket);
      return {
        orderId: deleteItemResp.basketId,
        orderItems: orderItemsArray,
        deleteItemResp,
        bundleData: isBundleTracker ? formatBundleData(res, orderItems, bundleDataItems) : [],
        isLoyaltyBenefitsCacheUpdate: isLoyaltyTieringEnabled,
      };
    })
    .catch((err) => {
      errorHandler(err, errorsMapping);
    });
};

// eslint-disable-next-line complexity
export const updateQueryForItemUpdate = (cache, data, cbParams) => {
  // eslint-disable-next-line camelcase
  const { c_couponMap, shipments, ...dataToUpdate } =
    (data && data.updateItemInBasket) || (data && data.updateBackpackItemInBasket);
  let isCacheExist = false;
  if (dataToUpdate) {
    isCacheExist = checkCache(cache);
  }
  if (isCacheExist && dataToUpdate) {
    cache.writeQuery({
      query: getCartCachedQuery,
      data: { getCart: dataToUpdate },
      // broadcast: false,
    });
    updateInventory(cache, { shipments, ...dataToUpdate }, cbParams);
  }
};
const calculatec_Accessories = (
  orderAccessoriesItem,
  productId,
  parentAccessorie,
  updateTypeBoolean
) => {
  if (!updateTypeBoolean) {
    return orderAccessoriesItem[productId]?.miscInfo?.c_accessories;
  }
  return parentAccessorie;
};

const findAccessoriesAndParents = (orderAccessoriesItem = {}, itemId = '') => {
  let hasAccessories = false;
  let hasMainProducts = false;
  try {
    if (orderAccessoriesItem && typeof orderAccessoriesItem === 'object') {
      Object.entries(orderAccessoriesItem).forEach((orderItem) => {
        const { miscInfo, itemInfo } = orderItem[1] || {};
        const { c_accessories = [], c_mainProducts = [] } = miscInfo || {};
        const { itemId: itemIdTemp } = itemInfo || {};
        if (itemIdTemp === itemId) {
          hasAccessories = c_accessories?.length > 0;
          hasMainProducts = c_mainProducts?.length > 0;
        }
      });
    }
    return { hasAccessories, hasMainProducts };
  } catch (e) {
    return { hasAccessories, hasMainProducts };
  }
};

const getRequestPayload = (
  params,
  orderAccessoriesItem,
  parentAccessorie,
  parentCustomizationType,
  updateTypeBoolean
) => {
  const {
    itemId,
    itemBrand,
    quantity,
    itemPartNumber: productId,
    skuInfo,
    multipackCatentryId,
    isHardMarkPrice,
    tcpLicensedProductBrand,
  } = params;
  const {
    prodPartNo = '',
    size = '',
    fit = '',
    TCPStyleType,
    TCPStyleQTY,
    TCPWebOnlyFlagStore,
    TCPProductIndStore = '',
    color = {},
    imageUrl = '',
    variantNo = '',
    listPrice,
    seoToken,
  } = skuInfo;
  const { hasAccessories, hasMainProducts } = findAccessoriesAndParents(
    orderAccessoriesItem,
    itemId
  );

  if (
    hasAccessories ||
    parentAccessorie.length > 0 ||
    hasMainProducts ||
    parentCustomizationType === 'optional'
  ) {
    let backpackItemType = hasAccessories ? 'mainProduct' : 'accessoryProduct';
    if (hasAccessories && hasMainProducts) {
      backpackItemType = 'multistyleProduct';
    }

    return {
      itemPayload: {
        itemId,
        productId,
        quantity: quantity && quantity.toString(),
        c_prodPartNo: prodPartNo,
        c_brand: itemBrand,
        c_size: size.toString(),
        c_fit: fit,
        c_TCPStyleType: TCPStyleType || '',
        c_TCPStyleQTY: TCPStyleQTY || '',
        c_TCPWebOnlyFlagStore: parseBoolean(TCPWebOnlyFlagStore),
        c_TCPProductIndStore: TCPProductIndStore,
        c_TCPColor: color.name,
        c_TCPimages: imageUrl,
        c_variant: variantNo,
        // add extra params here
        c_accessories: calculatec_Accessories(
          orderAccessoriesItem,
          productId,
          parentAccessorie,
          updateTypeBoolean
        ),
        c_mainProducts: orderAccessoriesItem[productId]?.miscInfo?.c_mainProducts,
        backpackItemType,
        c_seoToken: seoToken,
        c_list_price: listPrice,
        c_isHardMarkEnabled: isHardMarkPrice,
        c_TCPBigIdeaLicensedProductBrand: tcpLicensedProductBrand || '',
      },
    };
  }
  return {
    itemPayload: {
      itemId,
      productId,
      quantity: quantity && quantity.toString(),
      c_prodPartNo: prodPartNo,
      c_brand: itemBrand,
      c_multiPack: !!multipackCatentryId,
      c_multiPackItems: multipackCatentryId,
      c_size: size.toString(),
      c_fit: fit,
      c_TCPStyleType: TCPStyleType || '',
      c_TCPStyleQTY: TCPStyleQTY || '',
      c_TCPWebOnlyFlagStore: parseBoolean(TCPWebOnlyFlagStore),
      c_TCPProductIndStore: TCPProductIndStore,
      c_TCPColor: color.name,
      c_TCPimages: imageUrl,
      c_variant: variantNo,
      c_seoToken: seoToken,
      c_list_price: listPrice,
      c_isHardMarkEnabled: isHardMarkPrice,
      c_TCPBigIdeaLicensedProductBrand: tcpLicensedProductBrand || '',
    },
  };
};

/**
 *
 * @method updateItem
 * @description this method call updateItem API call for all types of item.
 * @param {*} payloadData
 * @returns
 */
export const updateItem = (
  payloadData,
  errorsMapping,
  orderAccessoriesItem = {},
  parentAccessorie = [],
  parentCustomizationType = '',
  updateTypeBoolean,
  { orderItems = [], bundleDataItems = [], isBundleTracker = false }
) => {
  const { itemId } = payloadData;
  const updatePayloadData = getRequestPayload(
    payloadData,
    orderAccessoriesItem,
    parentAccessorie,
    parentCustomizationType,
    updateTypeBoolean
  );
  const { itemPartNumber: productId } = payloadData;
  let isBackPackCall = false;
  if (
    orderAccessoriesItem[productId]?.miscInfo?.c_accessories?.length > 0 ||
    orderAccessoriesItem[productId]?.miscInfo?.c_mainProducts?.length > 0 ||
    parentCustomizationType === 'optional' ||
    parentCustomizationType === 'mandatory'
  ) {
    isBackPackCall = true;
  }
  const params = payloadData?.skuInfo || {};
  const { LoyaltyPromoPLCCMultiplierStore, LoyaltyPromoMultiplierStore, variantId, preOrderDate } =
    params;
  const callbackParams = {
    LoyaltyPromoPLCCMultiplierStore,
    LoyaltyPromoMultiplierStore,
    productId: variantId,
    preOrderDate,
  };
  return executeStatefulGraphQLQuery({
    query: isBackPackCall ? updateBackpackItemInBasket : updateItemInBasket,
    variables: updatePayloadData,
    type: 'mutation',
    callbackParams,
    updateQuery: updateQueryForItemUpdate,
  })
    .then((res) => {
      if (!res.data) {
        throw new Error(RES_NULL_ERROR);
      }
      const updatedItemResp =
        (res.data && res.data.updateItemInBasket) ||
        (res.data && res.data.updateBackpackItemInBasket);
      return {
        orderItemId: itemId,
        updatedItemResp: {
          ...updatedItemResp,
          productItems: formProdItemsWithLoyaltyAttr(updatedItemResp, params),
        },
        bundleData: isBundleTracker ? formatBundleData(res, orderItems, bundleDataItems) : [],
      };
    })
    .catch((err) => {
      throw graphQlErrorHandler(err, errorsMapping);
    });
};

const handleBonusDayCache = (cache, storeItemData) => {
  const isFreeGiftWrapping = hasGiftOptionWithPromotion(storeItemData?.productItems);
  let benefits = {};
  try {
    benefits = JSON.parse(storeItemData?.benefits || '{}');
  } catch (e) {
    console.error('Failed to parse benefits:', e);
  }

  const isGiftwrapperApplied = benefits.FreeGiftWrap;
  const storedData = cache.readQuery({ query: getLoyaltyBenefits });
  let updateData = storedData.getLoyaltyBenefits;

  if (isGiftwrapperApplied) {
    const isOnHold = !isFreeGiftWrapping;
    updateData = updateKeyWithValue(updateData, FREE_GIFT_WRAPPING, isOnHold, IS_ON_HOLD);

    if (!isOnHold) {
      updateData = updateKeyWithValue(updateData, FREE_GIFT_WRAPPING, true, IS_APPLIED_TO_BASKET);
    }
  }

  cache.writeQuery({
    query: getLoyaltyBenefits,
    data: { getLoyaltyBenefits: updateData },
  });
};
export const updateLoyaltyQueryForStoreItemUpdate = (cache, data, cbParams) => {
  const { shipments, paymentInstruments, billingAddress, ...dataToUpdate } =
    data?.updateStoreItemInBasket || data?.updateBackpackItemInBasket || {};

  if (!dataToUpdate) return;

  const isCacheExist = checkCache(cache);
  const isBonusDayCacheExist = checkCache(cache, 'getLoyaltyBenefits');

  if (isBonusDayCacheExist) {
    handleBonusDayCache(cache, data?.updateStoreItemInBasket);
  }

  if (isCacheExist) {
    cache.writeQuery({
      query: getCartCachedQuery,
      data: { getCart: dataToUpdate },
    });
    updateInventory(cache, { shipments, ...dataToUpdate }, cbParams);
  }
};

export const updateQueryForStoreItemUpdate = (cache, data, cbParams) => {
  const { shipments, paymentInstruments, billingAddress, ...dataToUpdate } =
    (data && data.updateStoreItemInBasket) || (data && data.updateBackpackItemInBasket) || {};
  let isCacheExist = false;
  if (dataToUpdate) {
    isCacheExist = checkCache(cache);
  }
  if (isCacheExist && dataToUpdate) {
    cache.writeQuery({
      query: getCartCachedQuery,
      data: { getCart: dataToUpdate },
    });
    updateInventory(cache, { shipments, ...dataToUpdate }, cbParams);
  }
};

const getRequestPayloadBOSS = (
  payloadData,
  orderAccessoriesItem,
  parentAccessorie,
  parentCustomizationType,
  updateTypeBoolean
) => {
  const payload = payloadData;
  if (payload?.accessories) {
    delete payload.accessories;
  }
  const { itemId = '', productId = '', toggle = null } = payload;
  const { hasAccessories, hasMainProducts } = findAccessoriesAndParents(
    orderAccessoriesItem,
    itemId
  );

  if (
    (hasAccessories ||
      parentAccessorie.length > 0 ||
      hasMainProducts ||
      parentCustomizationType === 'optional') &&
    !toggle
  ) {
    let backpackItemType = hasAccessories ? 'mainProduct' : 'accessoryProduct';
    if (hasAccessories && hasMainProducts) {
      backpackItemType = 'multistyleProduct';
    }

    return {
      itemPayload: payload,
      // eslint-disable-next-line no-dupe-keys
      itemPayload: {
        ...payload,
        c_accessories: calculatec_Accessories(
          orderAccessoriesItem,
          productId,
          parentAccessorie,
          updateTypeBoolean
        ),
        c_mainProducts: orderAccessoriesItem[productId]?.miscInfo?.c_mainProducts,
        backpackItemType,
      },
    };
  }
  return {
    itemPayload: payload,
  };
};

export const updateStoreItem = (
  payloadData,
  isLoyaltyTieringEnabled,
  errorsMapping,
  backPackParams
) => {
  const { itemId, productId, toggle = null } = payloadData;
  const {
    orderAccessoriesItem = {},
    parentAccessorie = [],
    parentCustomizationType = '',
    updateTypeBoolean,
    isBundleTracker = false,
    orderItems = [],
    bundleDataItems = [],
  } = backPackParams;
  const callbackParams = {
    productId,
  };
  const updatePayloadDataBOSS = getRequestPayloadBOSS(
    payloadData,
    orderAccessoriesItem,
    parentAccessorie,
    parentCustomizationType,
    updateTypeBoolean
  );
  let isBackPackCall = false;
  if (
    (orderAccessoriesItem[productId]?.miscInfo?.c_accessories?.length > 0 ||
      orderAccessoriesItem[productId]?.miscInfo?.c_mainProducts?.length > 0 ||
      parentCustomizationType === 'optional' ||
      parentCustomizationType === 'mandatory') &&
    !toggle
  ) {
    isBackPackCall = true;
  }
  const updateQueryFunction = isLoyaltyTieringEnabled
    ? updateLoyaltyQueryForStoreItemUpdate
    : updateQueryForStoreItemUpdate;

  return executeStatefulGraphQLQuery({
    query: isBackPackCall ? updateBackpackItemInBasket : updateStoreItemInBasket,
    variables: updatePayloadDataBOSS,
    type: 'mutation',
    callbackParams,
    updateQuery: updateQueryFunction,
  })
    .then((res) => {
      if (!res.data) {
        throw new Error(RES_NULL_ERROR);
      }
      const updateStoreItemResp =
        (res.data && res.data.updateStoreItemInBasket) ||
        (res.data && res.data.updateBackpackItemInBasket);
      return {
        orderItemId: itemId,
        updatedItemResp: { ...updateStoreItemResp },
        bundleData: isBundleTracker ? formatBundleData(res, orderItems, bundleDataItems) : [],
        isLoyaltyBenefitsCacheUpdate: isLoyaltyTieringEnabled,
      };
    })
    .catch((err) => {
      throw graphQlErrorHandler(err, errorsMapping);
    });
};

/**
 *
 * @method fetchBasketInventoryDetails
 * @description this method will fetch inventory for basket.
 * @param {*} basketId
 * @returns
 */
export const fetchBasketInventoryDetails = (cacheTTL, skipCache = true) => {
  const { preFix, defaultTTL } = CacheConfiguration.GET_INVENTORY_DETAILS;

  return executeStatefulGraphQLQuery({
    query: getBasketInventoryDetails,
    cacheConfigKey: `${preFix}`,
    TTL: cacheTTL || defaultTTL,
    fetchPolicy: skipCache ? NETWORK_ONLY : '',
  }).then((resp) => {
    if (!resp.data) {
      throw new Error(RES_NULL_ERROR);
    }
    return resp.data && resp.data.getBasketInventoryDetails;
  });
};
const prepareInvData = (baseData, dataToUpdate) => {
  const { productInventoryList } = dataToUpdate?.getBasketInventory || {};
  const inventoryData = baseData?.getBasketInventoryDetails;
  const { productList = [] } = inventoryData || {};
  let updatedList = [];
  if (productInventoryList && productList && productList.length > 0) {
    updatedList = productList.map((rcd) => {
      const invItem = productInventoryList.find((itm) => itm.productId === rcd.productId);
      if (invItem) {
        const { availableQty, requestedQty, outOfStock } = invItem;
        const { bopisInventory } = rcd;
        if (bopisInventory !== null) {
          const bopisInventoryData = { ...bopisInventory, atcQuantity: availableQty };
          return {
            ...rcd,
            availableQty,
            bopisInventory: bopisInventoryData,
            requestedQty,
            outOfStock,
          };
        }
        return { ...rcd, availableQty, requestedQty, outOfStock };
      }
      return rcd;
    });
  }

  return { ...inventoryData, productList: updatedList };
};
export const updateQueryForInvUpdate = (cache, data) => {
  const isCacheExist = checkCache(cache, 'getBasketInventoryDetails');
  if (isCacheExist) {
    const storedData = cache.readQuery({
      query: getBasketInventoryDetails,
    });
    const inventoryData = prepareInvData(storedData, data);
    cache.writeQuery({
      query: getBasketInventoryDetails,
      data: { getBasketInventoryDetails: inventoryData },
      // broadcast: false,
    });
  }
};
export const getUnqualifiedItems = (taxIdentifierAttribute) => {
  const orderItemList = [];
  const orderItemListAvl = [];
  const orderItemProductsList = [];
  const unavailableList = [];
  const availableList = [];

  return executeStatefulGraphQLQuery({
    query: getBasketInventory,
    fetchPolicy: 'no-cache',
    variables: { taxIdentifierAttribute },
    updateQuery: updateQueryForInvUpdate,
  })
    .then((resp) => {
      if (!resp.data) {
        throw new Error(RES_NULL_ERROR);
      }
      const basketInventory = resp.data?.getBasketInventory;
      const isTaxChanged = basketInventory?.taxUpdated;
      const basketError = basketInventory?.basketError;
      const inventoryData = basketInventory?.productInventoryList || [];
      inventoryData.forEach((element) => {
        const { availableQty = 0, requestedQty = 0 } = element;
        const isOOS = availableQty - requestedQty < 0;
        const obj = {
          orderItemId: element.itemId,
          isOOS,
          requestedQty,
        };
        if (isOOS) {
          orderItemList.push(obj);
          unavailableList.push(obj?.orderItemId);
        } else {
          availableList.push(obj?.orderItemId);
          orderItemListAvl.push(obj);
        }
        orderItemProductsList.push(obj);
      });
      return {
        orderItemList,
        isTaxChanged,
        orderItemListAvl,
        basketError,
        orderItemProductsList,
        availableList,
        unavailableList,
      };
    })
    .catch((err) => {
      throw err;
    });
};

/**
 *
 * @method paypalLookup
 * @description this method will fetch paypallookup details for basket.
 * @param {*} basketId callingPage
 * @returns
 */

export const startPaypalCheckoutAPI = async (basketId, callingPage, errorMapping) => {
  const basketid = readCookie('basketId') || basketId;
  const webService = endpoints.newpaypalLookUp;
  const payload = {
    webService: {
      ...webService,
      URI: `${webService.URI}${basketid}?callingPage=${callingPage}`,
    },
  };
  return executeStatefulAPICall(payload, getFormattedError, true)
    .then((res = { body: {} }) => {
      if (responseContainsErrors(res) || res.err) {
        throw new ServiceResponseError(res);
      }

      const responseObj = {};

      if (res.body !== undefined) {
        const { data } = res.body;

        Object.assign(responseObj, {
          centinelPayload: data.centinelPayload,
          centinelOrderId: data.centinelOrderId,
          centinelRequestPage: callingPage,
          tcpOrderId: data.orderNumber,
          paypalInContextToken: data.processorTransactionId,
        });
      }

      return responseObj;
    })
    .catch((err) => {
      throw getFormattedError(err, errorMapping);
    });
};

export const paypalAuthorizationAPI = (
  tcpOrderId,
  centinelRequestPage,
  centinelPayload,
  centinelOrderId,
  errorMapping
) => {
  const authPayloadData = {
    paypalAuth: {
      md: centinelOrderId,
      orderNumber: tcpOrderId,
      pares: centinelPayload,
    },
  };

  return executeStatefulGraphQLQuery({
    query: PaypalAuthenticationMutation,
    variables: authPayloadData,
    type: 'mutation',
  })
    .then((res) => {
      if (!res.data) {
        throw new Error(RES_NULL_ERROR);
      } else {
        return res.data.paypalAuthentication;
      }
    })
    .catch((err) => {
      throw graphQlErrorHandler(err, errorMapping);
    });
};

export async function getShipmentProductInventory(payload, errorsMapping = []) {
  const basketId = readCookie('basketId');
  return executeStatefulGraphQLQuery({
    variables: {
      basketId,
      shipmentProductInventoryRequest: { shipmentAndStoreDetails: payload },
    },
    query: shipmentProductInventory,
  })
    .then((resp) => {
      if (!resp.data) {
        throw new Error(`Error in shipmentProductInventory API call`);
      }
      return resp?.data?.shipmentProductInventory?.shipmentStoreProductInventories;
    })
    .catch((err) => {
      logger.error(`Error in shipmentProductInventory API call: ${err}`);
      throw graphQlErrorHandler(err, errorsMapping);
    });
}

export default {
  getCartCachedData,
  getCartNonCachedData,
  // getCartData,
  removeItem,
  updateItem,
  fetchBasketInventoryDetails,
  getUnqualifiedItems,
  startPaypalCheckoutAPI,
  paypalAuthorizationAPI,
  updateStoreItem,
  getShipmentProductInventory,
};
